import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/plugins/i18n';
import storage from '@/services/local-storage';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitchDialog',
  props: {
  lang: { type: String, required: true },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;




const dialog = ref(true);

const switchToNewLanguage = () => {
  i18n.locale = props.lang;
  storage.setLanguage(props.lang);
};

storage.setLanguagePromptDisplayed(true);


return { __sfc: true,props, emit, dialog, switchToNewLanguage }
}

})